var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 96,
    height: 96,
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.30769,33.07692c-3.64363,0 -6.61538,2.97176 -6.61538,6.61538v92.61538c0,3.64363 2.97176,6.61538 6.61538,6.61538h19.84615c3.64363,0 6.61538,-2.97176 6.61538,-6.61538v-92.61538c0,-3.64363 -2.97176,-6.61538 -6.61538,-6.61538zM105.84615,33.07692c-3.64363,0 -6.61538,2.97176 -6.61538,6.61538v92.61538c0,3.64363 2.97176,6.61538 6.61538,6.61538h19.84615c3.64363,0 6.61538,-2.97176 6.61538,-6.61538v-92.61538c0,-3.64363 -2.97176,-6.61538 -6.61538,-6.61538z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.464f3465.svg";
export { ForwardRef as ReactComponent };